import { motion } from 'motion/react'
import { useState } from 'react'
import { ReactQueryDevtoolsPanel } from '@tanstack/react-query-devtools'

import { Button } from '@mntn-dev/ui-components/buttons'

export const ReactQueryDevtools = () => {
  const [open, setOpen] = useState(false)

  if (process.env.NODE_ENV === 'production') {
    return null
  }

  return (
    <>
      <motion.div
        className="fixed bottom-0 left-0 right-0 z-999"
        animate={{ height: open ? 'auto' : 0 }}
      >
        <div className="relative">
          <ReactQueryDevtoolsPanel onClose={() => setOpen(false)} />
          {open && (
            <Button
              shape="square"
              iconLeft="close"
              onClick={() => setOpen(false)}
              variant="secondary"
              size="xs"
              className="absolute -top-4 -translate-y-full right-4 z-999"
            />
          )}
        </div>
      </motion.div>

      <Button
        shape="circle"
        iconLeft="TanstackQueryIcon"
        onClick={() => setOpen(!open)}
        variant="secondary"
        size="md"
        className="fixed right-6 bottom-20 [&>svg]:h-10 [&>svg]:w-10"
      />
    </>
  )
}
